import { Sparkles, ArrowRight } from "lucide-react";

const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function GuestBanner({ user }) {
  if (!user?.is_guest) return null;
  return (
    <div
      className="mb-6 rounded-2xl p-4 md:p-5 flex flex-col md:flex-row md:items-center justify-between gap-3"
      style={{
        background: "linear-gradient(135deg, rgba(216,168,87,0.12), rgba(216,168,87,0.04))",
        border: "1px solid rgba(216,168,87,0.35)",
      }}
      data-testid="guest-banner"
    >
      <div className="flex items-start gap-3">
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: "rgba(216,168,87,0.18)", border: "1px solid rgba(216,168,87,0.45)" }}
        >
          <Sparkles size={14} style={{ color: "var(--seal)" }} />
        </div>
        <div>
          <div className="eyebrow mb-1">Demo mode</div>
          <div className="font-heading text-base md:text-lg" style={{ fontVariationSettings: "'opsz' 32, 'wght' 500" }}>
            You&apos;re exploring as a <span className="font-display-italic">guest</span>.
          </div>
          <div className="text-xs mt-1" style={{ color: "var(--ink-72)" }}>
            Any work here will expire in 24 hours. Sign in with Google to keep it forever &amp; unlock the full studio.
          </div>
        </div>
      </div>
      <button
        onClick={startGoogleLogin}
        className="btn-primary flex-shrink-0"
        data-testid="guest-banner-signin"
      >
        Sign in to save <ArrowRight size={13} />
      </button>
    </div>
  );
}
